/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiProfileMin } from '../models/ApiProfileMin';
import { HttpFile } from '../http/http';

export class ApiDropVote {
    'vote': number;
    'voter': ApiProfileMin;
    'time': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "vote",
            "baseName": "vote",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "voter",
            "baseName": "voter",
            "type": "ApiProfileMin",
            "format": ""
        },
        {
            "name": "time",
            "baseName": "time",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiDropVote.attributeTypeMap;
    }

    public constructor() {
    }
}
